// extracted by mini-css-extract-plugin
export const awesome1 = "home-module--awesome1--gzjWU";
export const awesome2 = "home-module--awesome2--3QAOt";
export const btn = "home-module--btn--2Jhvd";